import { string } from 'prop-types';
import React from 'react';

import { allStatusesEnum as invoiceStatuses } from '../../balance/constants';
import { invoiceShape } from '../../prop-types';

function RequestedChanges({ invoice, className }) {
  return (
    invoice.status === invoiceStatuses.CHANGES_REQUESTED.value &&
    invoice.requestedChanges && (
      <div data-qa-field="inv-changesRequested" className={className}>
        &quot;
        {invoice.requestedChanges}
        &quot;
      </div>
    )
  );
}

RequestedChanges.propTypes = {
  invoice: invoiceShape.isRequired,
  className: string,
};

RequestedChanges.defaultProps = {
  className: '',
};

export default RequestedChanges;
